import { createApiBody } from '../../../api/api';
import call from '../../../api/axios';

export async function RegisterClient(data) {
	const body = createApiBody(
		'client',
		'registration',
		'RegisterClient',
		data,
	);

	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function ClientSignIn(data) {
	const body = createApiBody('user', 'auth', 'login', data);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result };
	} else {
		return { status: false };
	}
}
export async function SetCredentials(data) {
	const body = createApiBody('user', 'registration', 'createUser', data);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false, error: res.data.error };
	}
}

export async function VerifyClientOtp(data) {
	const body = createApiBody(
		'user',
		'registration',
		'registrationValidation',
		data,
	);

	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function FetchClientDetails(data) {
	const body = createApiBody('client', 'client', 'getClientDetails', data);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function UpdateClient(data) {
	const body = createApiBody('client', 'client', 'updateClient', data);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function ForgorPasswordRequest(data) {
	const body = createApiBody('user', 'auth', 'forgotPasswordRequest', data);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function ValidatePassword(data) {
	const body = createApiBody(
		'user',
		'auth',
		'forgotPasswordValidation',
		data,
	);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}

export async function UpdatePassword(data) {
	const body = createApiBody('user', 'auth', 'resetPasswordRequest', data);
	const res = await call.post('', body);
	if (res.status) {
		return { status: true, data: res.data.result.data };
	} else {
		return { status: false };
	}
}
